import { Modal } from "../ui/modal/Modal"
import { ModalError } from "../ui/modal/ModalError"
import { ModalOk } from "../ui/modal/ModalOk"
import { msg } from "../ui/modal/utils"
import { useState } from "react"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"

import { useQuery } from "../../hooks/useQuery"
import { Trans, useTranslation } from "react-i18next"

export const ModalEditarTag = ({ show, entry, setEntries }) => {
  const [tag, setTag] = useState(entry)

  const updateTag = useQuery(),
    showRes = useState(false)

  const runQuery = async () => {
    showRes[1](true)

    // recolecto toda la data necesaria para el fetch
    const tkn = getCookie("jwt"),
      { url, opt } = api.tags.update({ token: tkn, tag_id: tag.id, tag })

    // ejecuto
    updateTag.url.current = url
    updateTag.opt.current = opt

    updateTag.run({
      onOk: () => {
        setEntries((current) => ({
          total: current.total,
          entries: current.entries.map((c) => {
            if (c.id !== entry.id) return c
            return tag
          }),
        }))
      },
    })
  }

  const { t } = useTranslation()

  const bodyModalEditarTag = () => {
    return (
      <>
        <div className="p-3 pt-0" style={{ background: "hsl(0deg 0% 90%)" }}>
          <div className="form-group">
            <label className="form-label mt-4">{t(`admin.tags.name`)}</label>
            <input
              onChange={(e) => {
                setTag((current) => ({ ...current, name: e.target.value }))
              }}
              value={tag.name}
              className="form-control"
              placeholder={t(`admin.tags.placeholder_name`)}
            />
          </div>

          <div className="form-group mt-4 d-flex align-items-center">
            <label className="form-label mb-0">
              {t(`admin.tags.is_visible`)}
            </label>
            <input
              type="checkbox"
              className="ms-3"
              checked={tag.visible}
              onChange={(e) =>
                setTag((current) => ({ ...current, visible: e.target.checked }))
              }
            />
          </div>
        </div>
      </>
    )
  }

  const footerModalEditarTag = () => {
    const handleCancelar = () => show[1](false)
    return (
      <>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleCancelar()}>
          {t(`ui.btns.cancel`)}
        </button>

        <button
          type="button"
          className="btn btn-primary"
          disabled={updateTag.isPending}
          onClick={() => runQuery()}>
          {updateTag.isPending
            ? t(`ui.btns.submiting`) + "..."
            : t(`ui.btns.save`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="editar-tag"
        show={show}
        header={<center>{t(`modals.modal_edit_tag.header`)}</center>}
        body={bodyModalEditarTag()}
        footer={footerModalEditarTag()}
      />

      {/* modales para los resultados */}

      {updateTag.res && !updateTag.err && (
        <ModalOk
          show={[showRes[0], show[1]]}
          body={msg(
            <Trans
              i18nKey="modals.modal_edit_tag.sucess_msg"
              values={{ tag: tag.name }}
              components={{ i: <i /> }}
            />
          )}
        />
      )}

      {updateTag.res && updateTag.err && (
        <ModalError show={showRes} res={updateTag.res} />
      )}
    </>
  )
}
